<script>
import Tabs from '@/components/Tabs';
import Form from './Form';
import Invitations from './Invitations';

export default {
  name: 'ModuleUsersEdition',
  components: {
    Tabs,
  },
  data() {
    return {
      tabs: [
        {
          label: 'General',
          component: Form,
        },
        {
          label: 'Invitations',
          component: Invitations,
        },
      ],
    };
  },
  created() {
    if (!this.$route.params || !this.$route.params.id) {
      this.$router.push({ name: 'users-listing' });
    }
  },
};
</script>
<template>
  <div class="box">
    <Tabs :tabs="tabs" />
  </div>
</template>
